export const CLICKFUNNEL_CONTACT_URL = 'https://www.pages.anyway.ai/contact-us';

export const CLICKFUNNEL_PRIZE_TERMS_AND_CONDITIONS_URL = 'https://www.pages.anyway.ai/prize-terms-conditions63691206';
